import { useTranslation } from "react-i18next";
import {
  MotifButton,
  MotifFormField,
} from "@ey-xd/motif-react";
import {
  CLOSE_BUTTON_VARIANT,
  getCommonCloseImg,
} from "@/components/Images/CommonImages";

interface TitleComplementProps {
  setShowBasicSearch: any;
  showBasicSearch: any;
  clearSearch: any;
  clearBasicSearch: any;
}

const TitleComplement = ({
  setShowBasicSearch,
  showBasicSearch,
  clearSearch,
  clearBasicSearch,
}: TitleComplementProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        showBasicSearch ? "show-and-hide-quicksearch" : "show-quick-search"
      }
    >
      <MotifFormField>
        <MotifButton
          type="button"
          onClick={() => {
            setShowBasicSearch(true);
          }}
          variant="secondary"
        >
          {t("pages.tasks.search.basicSearch")}
        </MotifButton>
        {clearSearch ? (
          <div className="search-div">
            <MotifButton
              size="small"
              variant={CLOSE_BUTTON_VARIANT}
              onClick={() => {
                clearBasicSearch();
              }}
              type="button"
              title="Clear Search"
            >
              {getCommonCloseImg()}
            </MotifButton>
          </div>
        ) : (
          ""
        )}
      </MotifFormField>
    </div>
  );
};
export default TitleComplement;
